import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { motion } from "framer-motion";

import { governingBodyData } from "../data/governingBodyData";
import AnimatedPage from "../component/LeadershipComponents/AnimatedPage";
import HorizontalScroller from "../component/LeadershipComponents/HorizontalScroller";
import ProfileCard from "../component/LeadershipComponents/ProfileCard";
import Navbar from "../component/Navbar";
import Footer from "../component/Footer";

const GoverningBodyProfile = () => {
  const { id } = useParams();

  // ✅ Scroll to top whenever profile changes
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [id]);

  // Combine all members
  const allMembers = governingBodyData.chairperson
    ? [governingBodyData.chairperson, ...governingBodyData.members]
    : governingBodyData.members;

  const person = allMembers.find((p) => p.id === id);

  if (!person) {
    return (
      <>
        <Navbar />
        <div className="text-center py-32 text-xl font-medium">
          Member not found
        </div>
        <Footer />
      </>
    );
  }

  // build suggestion list excluding current profile and remove duplicates (same name/image)
  let suggestions = allMembers.filter((p) => p.id !== id);
  suggestions = suggestions.filter(
    (p, idx, arr) => arr.findIndex(q => q.name === p.name) === idx
  );
  console.log('Suggestions:', suggestions);
  return (
    <>
      <Navbar />

      <AnimatedPage>
        <div className="bg-gradient-to-b from-white to-gray-50 min-h-screen">
          <div className="max-w-6xl mx-auto px-6 py-20">

            {/* ===== Top Section ===== */}
            <motion.div
              initial={{ opacity: 0, y: -60 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="flex flex-col md:flex-row items-center md:items-start gap-14 mb-20"
            >
              {/* Image */}
              <div className="w-64 h-64 md:w-72 md:h-72 rounded-full overflow-hidden border-4 border-blue-200 shadow-2xl">
                <img
                  src={person.image}
                  alt={person.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Name + Designation */}
              <div className="text-center md:text-left">
                <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
                  {person.name}
                </h1>

                <p className="text-xl md:text-2xl text-blue-600 font-medium">
                  {person.designation}
                </p>
              </div>
            </motion.div>

            {/* ===== Biography Section ===== */}
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.4, duration: 0.8 }}
              className="bg-white rounded-3xl shadow-lg p-10 mb-24"
            >
              <h2 className="text-3xl font-semibold text-blue-800 mb-8">
                Biography
              </h2>

              {person.fullProfile ? (
                <div className="space-y-6 text-gray-700 leading-relaxed text-lg">
                  <p>{person.fullProfile.bio}</p>
                </div>
              ) : (
                <p className="text-gray-600 text-lg">
                  Detailed profile coming soon.
                </p>
              )}
            </motion.div>

            {/* ===== Suggestions Section ===== */}
            {suggestions.length > 0 && (
              <section>
                <h3 className="text-3xl font-bold text-blue-900 mb-10">
                  Other Governing Body Members
                </h3>

                <HorizontalScroller>
                  {suggestions.map((suggestion) => (
                    <div
                      key={suggestion.id}
                      className="min-w-[280px] max-w-[280px]"
                    >
                      <ProfileCard person={suggestion} basePath="governing-body" />
                    </div>
                  ))}
                </HorizontalScroller>
              </section>
            )}
          </div>
        </div>
      </AnimatedPage>

      <Footer />
    </>
  );
};




export default GoverningBodyProfile;